// extracted by mini-css-extract-plugin
export default {"header-container":"BrowserProperty_header-container__L9b79"};